export const msalConfig = {
  authority: process.env.REACT_APP_BASE_URL_AUTHORITY,
  clientId: process.env.REACT_APP_BASE_URL_CLIENT_ID,
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    // cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  redirectUri: process.env.REACT_APP_BASE_URL_REDIRECT,
};
